module.exports = __webpack_public_path__ + "assets/img/0a58df81a175ba96c8ccab24e44643ca.png";